import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Broker, Platform } from '@c4/core';
import { ConnectedDeviceService, NetworkService } from '../services';

import { ActiveMenuItemsPipe } from '../pipes/active-menu-items.pipe';

@Component({
  selector: 'sysman-menu',
  templateUrl: './sysman-menu.component.html',
  host: {
    '(document:click)': 'onClick($event)',
  }
})
export class SysmanMenuComponent implements OnInit {

  @Input() selectedRoute: string;
  @Input() connectedDevice: any; 
  @Input() brokerHostAddress: string;

  menu: {
    route: string,
    display: string,
    hidden: boolean
  }[] = [
    { route: 'details', display: 'Network', hidden: false },
    { route: 'services', display: 'Status', hidden: false },
    { route: 'logging', display: 'Logging', hidden: false },
//    { route: 'setup', display: 'VPN Host', hidden: false },
    { route: 'time', display: 'Time', hidden: false },
    { route: 'packages', display: 'Packages', hidden: false },
    { route: 'outputlog', display: 'Output Log', hidden: false }
  ];

  constructor(private router: Router, private route: ActivatedRoute,
    private broker: Broker, private platform: Platform,
    private connectedDeviceService: ConnectedDeviceService,
    private networkService: NetworkService,
    private _elementRef: ElementRef) {
  }

  ngOnInit() {
    if (this.connectedDevice) {
      // disable VPN page for non-broker hosts
      //if (this.connectedDevice.address != this.brokerHostAddress)
      //  this.disableMenuItem("setup");
      
      // disable Logging page for IO Xtenders
      let uuid = this.connectedDevice.uuid;
      if (uuid) {
        if (uuid.indexOf("xtender") > -1) {
          this.disableMenuItem("logging");
          this.disableMenuItem("time");
        }
        else // don't allow Time page for touch screens
        if ((uuid.indexOf("glassedge") > -1) || (uuid.indexOf("bcm-") > -1) || (uuid.indexOf("touchpanel-") > -1)) {
          this.disableMenuItem("time");
        }
        else
        if (uuid.indexOf("sony-avr") > -1) {
          this.disableMenuItem("time");
          this.disableMenuItem("logging");
          this.disableMenuItem("packages");
        }
      }
    }
  }

  ngOnDestroy() {
  }

  goMenu(_route: string) {
    this.router.navigate(["../../sysman/" + _route], { relativeTo: this.route });
  }

  // gets the director version from a platform_status broker result
  getDirectorVersion(platformStatus: any): string {

    var directorVersion = "";
    if (platformStatus.versions && (platformStatus.versions.length > 0)) {
      var director = platformStatus.versions.filter(item => {
        return (item.name == "Director");
      });
      if (director.length > 0) {
        directorVersion = director[0].version;
      }
    }
    return directorVersion;
  }

  disableMenuItem(routeName : string) {
    var findRoute = this.menu.filter(item => {
      return (item.route == routeName);
    });
    if (findRoute.length > 0)
      findRoute[0].hidden = true;
  }

  toggleDropDown() {
    this._showDropDown = !this._showDropDown;
  }

  onClick(event: MouseEvent) {
    if (!this._elementRef.nativeElement.contains(event.target)) {
      this._showDropDown = false;
    }
  }

  private _showDropDown: boolean = false;
}



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/sysman-menu/sysman-menu.component.ts